module.exports = __webpack_public_path__ + "static/Robbie-Loya-ebe36633ef042002f8efa322f981a74a.jpg";